<template>
    <div>
        <select-bar
                class="p-p-3 p-d-flex p-jc-between"
                v-on:updateGrade="updateGrade"
                v-on:updateReportName="updateReportName"
                ref="select-bar"
        ></select-bar>
        <menage-list
                class="p-p-3"
                :selectedGrade="selectedGrade"
                :selectedReportName="selectedReportName"
        ></menage-list>
    </div>
</template>

<script>
import SelectBar from '@/views/report/menageReport/menageSelectBar.vue'
import MenageList from '@/views/report/menageReport/menageList.vue'

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"

export default {
    name: "menage-report",
    components: {
        MenageList,
        SelectBar
    },
    data() {
        return {
            //     componentKey: 0,
            selectedGrade: null,
            selectedReportName: null,
        }
    },
    methods: {
        updateGrade(grade) {
            this.selectedGrade = grade
        },
        updateReportName(name) {
            this.selectedReportName = name
        },
    },
}
</script>

<style scoped>

</style>